import React from 'react';
import { useTranslation } from 'react-i18next';
import { TFunction } from "i18next";
import styles from './SetupCard.module.scss';
import { SetupProps } from 'LearningManager/constants/createAssignment.constant';
import { Icon } from 'Components';
import classNames from 'classnames';

interface SetupCardComponentProps extends SetupProps {
	id?: string;
}

const SetupCard: React.FC<SetupCardComponentProps> = ({
	id,
	translationKey,
	icon,
	selectedIcon,
	list,
	isRecommended,
	isActive,
	onClick
}) => {
	const { t } = useTranslation();

	return (
		<div
			id={id}
			className={classNames(styles.container, {
				[styles['container--active']]: isActive
			})}
			onClick={onClick}
		>
			{isRecommended && <RecommendTag t={t} />}

			<div className={styles['heading-container']}>
				<div
					className={classNames(styles.heading, {
						[styles['heading--active']]: isActive
					})}
				>
					<div
						className={classNames(styles.icon, {
							[styles['icon--active']]: isActive
						})}
					>
						{isActive && selectedIcon ? selectedIcon : icon}
					</div>

					{t(`${translationKey}.title`)}
				</div>

				<div className={styles.subHeading}>
					{t(`${translationKey}.subTitle`)}
				</div>
			</div>

			<div className={styles.divider} />

			<div className={styles.listTitle}>{t(`${translationKey}.listTitle`)}</div>

			<ul className={styles.list}>
				{list.map((item: string, index: number) => (
					<li key={index}>{t(`${translationKey}.list.${index}`)}</li>
				))}
			</ul>
		</div>
	);
};

const RecommendTag = ({ t } : { t: TFunction}) => {
	return (
		<div className={styles.recommended}>
			<Icon type="reccStarsIcon" role="img" />
			{t('learning.createAssignment.setupOptions.recommended')}
		</div>
	);
};

export default SetupCard;